import { User } from './User';

export interface Recharge {
  id: string;
  user_id: string;
  description: string;
  credits: number;
  price: number;
  total: number;
  created_at: Date;
  created_by: string;
  updated_at: Date;
  confirmated_at: Date;
  payment_type: string;
  payment_status: string;
  integration_id: string;
  target: string;
  target_name: string;
  invoice_status: number;
  invoice_date: string;
  invoice_url: string;
  type: number;

  /**
   * Bônus creditado nesta recarga, em micros (CU-86akn0zp6). `null` ou ausente é
   * recarga sem bônus — inclusive toda a base anterior à recarga por valor, que
   * nunca teve o campo. Zero e ausência leem igual na tela, e por isso a coluna
   * só aparece quando há bônus.
   */
  bonus_micros?: number | null;

  user: User;
}

// tipos de recarga (espelho de UserRecharge no backend)
export const RECHARGE_TYPE_DOMAIN_ADDON = 7;

export const INVOICE_PENDING = 0;
export const INVOICE_PROCESSING = 1;
export const INVOICE_OK = 2;
export const INVOICE_FAILED = 3;
export const INVOICE_NO_LONGER_PROCESS = 99;
